import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminSponsorModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminSponsorModule;